<div class="container-fluid">
   <div class="row h-100">
      <div class="col-12">
         <!-- Loading indicator -->
         <div *ngIf="loading" class="d-flex justify-content-center align-items-center h-100">
            <div class="spinner-grow text-dark" role="status"></div>
            <div class="spinner-grow text-dark" role="status"></div>
            <div class="spinner-grow text-dark" role="status"></div>
         </div>
         <!-- End Loading endicator -->

         <!-- Error view  -->
         <div *ngIf="showNoData" class="d-flex justify-content-center align-items-center h-100">
            <div class="alert alert-danger" role="alert">
               <div *ngIf="isKnownError">
                  <h5 class="alert-heading">{{ translatePath + 'error.title' | translate }}</h5>
                  <p class="mb-0 mt-4">
                     <strong>{{ translatePath + 'error.' + errorMessage + '.title' | translate }}</strong>
                  </p>
                  <p>
                     <span> {{ translatePath + 'error.' + errorMessage + '.description' | translate }}</span>
                  </p>
               </div>
               <div *ngIf="!isKnownError">
                  <h5 class="alert-heading">{{ translatePath + 'error.title' | translate }}</h5>
                  <p class="mb-0 mt-4">
                     <strong>{{ errorMessage }}</strong>
                  </p>
               </div>
               <hr />
               <p class="mb-0 pb-0 mt-3">
                  {{ 'public.shipping-summary.order-id' | translate }}: <strong>{{ orderId }}</strong>
               </p>
               <p class="mt-0 pt-0">
                  {{ 'general.typeOfProducts.labels.serviceId' | translate }}:<strong> {{ serviceId }}</strong>
               </p>
            </div>
         </div>
         <!-- End error view -->

         <div class="card step mr-auto ml-auto mt-5" *ngIf="isOrderInsertedAndPaid">
            <p class="alert-info">{{ translatePath + 'this-Order-Was-Paid' | translate }}</p>
         </div>

         <div
            class="d-flex flex-column w-100"
            *ngIf="serviceProviderResponse && orderDetails && !isOrderInsertedAndPaid"
         >
            <div class="row">
               <div class="col-12 col-md-8">
                  <app-shipping-address
                     [orderDetails]="orderDetails"
                     (formValueEmitter)="moveToSecondStep($event)"
                     (internationalShippment)="shippment($event)"
                     (editModeEmitter)="editModeEmitter($event)"
                  >
                  </app-shipping-address>
                  <app-shipping-options (optionEmitter)="newOptionSelected($event)"></app-shipping-options>

                  <app-shipping-summary
                     [order]="orderDetails"
                     [option]="this.option"
                     [providerData]="serviceProviderResponse"
                     class="summary"
                  >
                  </app-shipping-summary>

                  <app-shipping-final
                     (payOrder)="pay()"
                     [idDelivery]="idDelivery"
                     [loading]="paymentLoading"
                     [shippingAddress]="shippingAddress"
                     [serviceProviderResponse]="serviceProviderResponse"
                     [option]="this.option"
                  >
                  </app-shipping-final>
               </div>
               <div
                  class="col-md-4 summary-size"
                  *ngIf="serviceProviderResponse && orderDetails && !isOrderInsertedAndPaid"
               >
                  <app-shipping-summary
                     [order]="orderDetails"
                     [option]="this.option"
                     [providerData]="serviceProviderResponse"
                  >
                  </app-shipping-summary>
                  <button
                     class="btn btn-primary btn-block mt-3 text-capitalize"
                     (click)="printDeliveryDetails()"
                     [disabled]="!isConfirm"
                  >
                     Printare adresă
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
